import { render, staticRenderFns } from "./Vrshow.vue?vue&type=template&id=24fe38a9&scoped=true&"
import script from "./Vrshow.vue?vue&type=script&lang=js&"
export * from "./Vrshow.vue?vue&type=script&lang=js&"
import style0 from "./Vrshow.vue?vue&type=style&index=0&id=24fe38a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe38a9",
  null
  
)

export default component.exports